import {capitalize, filter, map} from 'lodash';
import {FormProvider, useForm} from 'react-hook-form';

import ButtonPanel from 'components/Button/Panel';
import FormCancel from 'components/form/Cancel';
import FormCombobox from 'components/form/Combobox';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


const typeOptions = [
  {label: 'Multinational', value: 'MULTINATIONAL'},
  {label: 'Startup', value: 'STARTUP'},
];

export default function CompanyForm({company, techStackOptions, onSave, onClose}) {
  const appContext = useAppContext();

  const languageOptions = filter(techStackOptions, (o) => o.category === 'LANGUAGE');
  const frontendOptions = filter(techStackOptions, (o) => o.category === 'FRONTEND');
  const backendOptions = filter(techStackOptions, (o) => o.category === 'BACKEND');
  const databaseOptions = filter(techStackOptions, (o) => o.category === 'DATABASE');
  const devOpsOptions = filter(techStackOptions, (o) => o.category === 'DEVOPS');
  const aiOptions = filter(techStackOptions, (o) => o.category === 'AI');

  const selectedLanguage = filter(company?.techStacks, (ts) => ts.category === 'LANGUAGE');
  const selectedFrontend = filter(company?.techStacks, (ts) => ts.category === 'FRONTEND');
  const selectedBackend = filter(company?.techStacks, (ts) => ts.category === 'BACKEND');
  const selectedDatabase = filter(company?.techStacks, (ts) => ts.category === 'DATABASE');
  const selectedDevOps = filter(company?.techStacks, (ts) => ts.category === 'DEVOPS');
  const selectedAI = filter(company?.techStacks, (ts) => ts.category === 'AI');
  
    
  const formMethods = useForm({
    defaultValues: {
      companyName: company?.companyName ?? '',
      country: company?.country ?? '',
      size: company?.size ?? '',
      industry: company?.industry ?? '',
      type: company?.type ? {label: capitalize(company?.type), value: company?.type} : '',
      language: selectedLanguage?.length > 0
        ? map(selectedLanguage, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      frontend: selectedFrontend?.length > 0
        ? map(selectedFrontend, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      backend: selectedBackend?.length > 0
        ? map(selectedBackend, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      database: selectedDatabase?.length > 0
        ? map(selectedDatabase, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      devOps: selectedDevOps?.length > 0
        ? map(selectedDevOps, (l) => ({label: l.techStackName, value: l.techStackName}))
        : [],
      ai: selectedAI?.length > 0 ? map(selectedAI, (l) => ({label: l.techStackName, value: l.techStackName})) : [],
    },
  });

  const {handleSubmit, setError} = formMethods;
  
  const onSubmit = async (values) => {
    const apiMethod = company?.companyId ? appContext.api.put : appContext.api.post;
    const urlVal = 'api/v1/companies';
    const apiUrl = company?.companyId ? `${urlVal}/update/${company.companyId}` : urlVal + '/create';
    const techStackNames = [
      ...map(values?.language, (val) => val.value),
      ...map(values?.frontend, (val) => val.value),
      ...map(values?.backend, (val) => val.value),
      ...map(values?.database, (val) => val.value),
      ...map(values?.devOps, (val) => val.value),
      ...map(values?.ai, (val) => val.value),
    ];
    try {
      const rez = await apiMethod(apiUrl, {
        json: {
          companyName: values?.companyName,
          country: values?.country,
          size: values?.size,
          industry: values?.industry,
          type: values?.type?.value,
          techStackNames,
        },
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <h3>Add New Company</h3>
        <FormText
          name="companyName"
          label="Company name"
          required={true}
        />
        <FormText
          name="country"
          label="Country"
          required={true}
        />
        <FormText
          name="size"
          label="Number of employees"
          required={true}
        />
        <FormText
          name="industry"
          label="Industry"
          required={true}
        />
        <FormCombobox
          label="Company type"
          name="type"
          options={typeOptions}
          isMulti={false}
          required={true}
        />
        <FormCombobox
          name="language"
          label="Language"
          isMulti={true}
          options={languageOptions}
          required={true}
        />
        <FormCombobox
          name="frontend"
          label="Frontend"
          isMulti={true}
          options={frontendOptions}
        />
        <FormCombobox
          name="backend"
          label="Backend"
          isMulti={true}
          options={backendOptions}
        />
        <FormCombobox
          name="database"
          label="Database"
          isMulti={true}
          options={databaseOptions}
        />
        <FormCombobox
          name="devOps"
          label="Devops"
          isMulti={true}
          options={devOpsOptions}
        />
        <FormCombobox
          name="ai"
          label="AI"
          isMulti={true}
          options={aiOptions}
        />
        
        <ButtonPanel
          buttons={[
            <FormSubmit key="save">Save</FormSubmit>,
            <FormCancel key="cancel" actionHandler={onClose}>Cancel</FormCancel>,
          ]}
        />
      </form>
    </FormProvider>
  );
    
}
